import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { DEFAULT_WAREHOUSE, NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean } from "../ds/client_ds.js";
import {
  FabricStyleBean,
  FabricStyleInventoryAdjustmentSearchCriteria,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  InventoryLocationTransferBean,
  InventoryLocationTransferLineBean,
  InventoryLocationTransferSearchCriteria,
  PageListBean,
  PurchaseOrderReceiptSearchCriteria,
  ReasonBean,
  RestEntityUnLockRequest,
  RestFabricStyleInventoryAdjustmentListRequest,
  RestFabricStyleListBeanRequest,
  RestFabricStyleListRequest,
  RestInventoryEntityRequest,
  RestInventoryTransferListRequest,
  RestPageListBean,
  RestPurchaseOrderReceiptListRequest,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  RollsSearchCriteria,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { InventoryAdjustmentLookupHandler } from "../lookup/InventoryAdjustmentLookupHandler.js";
import { InventoryTransferLookupHandler } from "../lookup/InventoryTransferLookupHandler.js";
import { PurchaseOrderReceiptLookupHandler } from "../lookup/PurchaseOrderReceiptLookupHandler.js";
import { RollSkuLookupHandler } from "../lookup/RollSkuLookupHandler.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import CustomTable from "../gui_components/CustomTable.js";
import { ModuleUtils } from "./ModuleUtils.js";

class InventoryTransferList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.fabricStyleColorCodeRef = React.createRef();
    this.fabricStyleCodeRef = React.createRef();
    this.state = {
      pageTitle: "Inventory Transfer Maintenance",
      inventory_transfer_list: [],
      companyCode: "",
      pageList: new RestPageListBean(),
      isLoading: false,
      criteria: new InventoryLocationTransferSearchCriteria(),
      inventoryTransferData: new InventoryLocationTransferBean(),
      inventoryTransferLineData: new InventoryLocationTransferLineBean(),
      isDisableFields: false,
      currentPageNumber: 0,
      totalCount: 0,
      isListMode: false,
      isEntryMode: false,
      isShowSaveButton: false,
      isShowCancelButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowPDFReportButton: false,
      isTransferEntryFormOpen: false,
      isInventoryTransferListFormOpen: true,
      error_list: [],
      companyConfig: new Array(),
      isLoading: false,
      inventoryTransferReasons: [],
      reasonData: new ReasonBean(),
      warehouses: [],
      documentTypes: [],
      fabricStyle_List: [],
      finalColorList: [],
      currentFabricStyle: new FabricStyleBean(),
      nodeList: [],
      selectedNodeKey: "headerView",
      isShowNodes: false,
      isLoadReceiptButton: false,
      isAddRollFabricButton: false,
      isLoadBinInventoryButton: false,
      rollCriteria: new RollsSearchCriteria(),
      adjustmentCriteria: new FabricStyleInventoryAdjustmentSearchCriteria(),
      receiptCriteria: new PurchaseOrderReceiptSearchCriteria(),
      fabricStyleRollList: [],
      adjustmentList: [],
      receiptList: [],
      receiptLines: [],
      roll_Lines: [],
      adjustmentNewLines: [],
      inventoryRollList: [],
      binInventoryList: [],
      isResetModule: false,
      moduleForPopup: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      inventoryTransferLookupHandler: null,
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      isResetModule: false,
      moduleOrderStatus: "",
      disableFormFields: false,
      isShowColorLookup: false,
      isShowRollSkuLookup: false,
      disabled: false,
      isResetView: true,
      isFocus: false,
      isFocusLookup: true,
      excelInventoryList: [],
      isShowExcelDataPopup: false,
      fileName: "",
      selectedExcelDataList: [],
      excelIncompleteInventoryList: [],
      order: "asc",
      sortField: "",
      rollSkuLookupHandler: null,
      isDisabledFields: false,
      isLoadExcelButton: true,
      lookup_data: [],
      isShowReceiptPopup: false,
      isShowAdjustmentPopup: false,
      isShowAutoCompleteFromLocationList: false,
      fromLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteToLocationList: false,
      toLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteDocumentList: false,
      documentPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteTransferReasonList: false,
      transferReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteColorList: false,
      colorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRollSkutList: false,
      rollSkuPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjustmentList: false,
      adjustmentPageListForAutoCompleteList: new Array(),
      isShowAutoCompletepurchaseReceiptList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      inventoryTransferLines: [],
      is3PL: false,
      isReseted: false,
      isViewMode: false,
      userInput: "",
      isMaintenanceMode: true,
      isTexco: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;

    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (ConfigManager.isTexcoFabricKey()) {
      this.state.isTexco = true;
      this.setState({
        isTexco: true,
      });
    }
    this.state.criteria = new InventoryLocationTransferSearchCriteria();
    this.state.criteria.companyCode = this.companyCode;
    this.state.pageList = new RestPageListBean();
    this.state.pageList.pageSize = 50;
    this.fetchAttributesFromLocalStorage();
    this.getFabricStyleList();
    this.getReceiptList();
    this.getInventoryAdjustmentList();
    this.initLookupHandlers();
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;
      this.editInventoryTransfer(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
      // this.loadInventoryTransferPage();
    }
  }
  initLookupHandlers = () => {
    let inventoryTransferLookupHandler = new InventoryTransferLookupHandler(
      this.companyCode,
      "Inventory Transfer",
    );
    this.setState({
      inventoryTransferLookupHandler: inventoryTransferLookupHandler,
    });
  };
  fetchAttributesFromLocalStorage = () => {
    const attribute_cache = { ...this.cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let warehouses = attribute_cache.warehouses;
    let warehouses_temp = [];
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        warehouses_temp.push(attr);
        this.state.warehouses = ModuleUtils.isActiveAttribute(warehouses_temp);
      });
    }
    let inventoryTransferReasons = attribute_cache.inventoryAdjustmentReasons;
    let inventoryTransferReasons_temp = [];
    if (
      inventoryTransferReasons != null ||
      inventoryTransferReasons != undefined
    ) {
      inventoryTransferReasons.map((attr) => {
        inventoryTransferReasons_temp.push(attr);
        this.state.inventoryTransferReasons = ModuleUtils.isActiveAttribute(
          inventoryTransferReasons_temp,
        );
      });
    }
    let documentTypes = attribute_cache.documentTypes;
    let documentTypes_temp = [];
    if (documentTypes != null || documentTypes != undefined) {
      documentTypes.map((attr) => {
        documentTypes_temp.push(attr);
        this.state.documentTypes =
          ModuleUtils.isActiveAttribute(documentTypes_temp);
      });
    }
  };
  loadInventoryTransferPage = () => {
    let requestInput = new RestInventoryTransferListRequest();
    requestInput.pageInput = this.state.pageList;
    requestInput.searchCriteria = this.state.criteria;
    if (SecurityAccessManager.InventoryTransferMaintenanceView_IsAccessible()) {
      InventoryService.getInventoryLocationTransferPageList(
        requestInput,
        this.loadInventoryTransferResponse,
        this.loadInventoryTransferError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadInventoryTransferResponse = (response) => {
    const inventory_transfer_list =
      response.data.inventoryLocationTransferPageList
        .inventoryLocationTransfers;
    let pageList = this.state.pageList;
    pageList.totalCount =
      response.data.inventoryLocationTransferPageList.totalCount;
    pageList.currentPage =
      response.data.inventoryLocationTransferPageList.currentPage;

    if (inventory_transfer_list == null) {
      inventory_transfer_list = new Array();
    }
    this.setState({
      isLoading: false,
      inventory_transfer_list: inventory_transfer_list,
      pageList: pageList,
    });
  };
  loadInventoryTransferError = (error) => {
    ShowError("loadInventoryTransferError" + error);
  };
  searchOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria["transferCode"] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let pageList = this.state.pageList;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadInventoryTransferPage();
  };
  filterInventoryTransfer = () => {
    this.loadPage(1);
  };
  resetfilteredTransfer = (criteria) => {
    criteria = new InventoryLocationTransferSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
    criteria.transferCode = "";
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  getReceiptList = () => {
    let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
    receiptCriteria.companyCode = this.companyCode;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = receiptCriteria;
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadPurchaseReceiptResponse,
        this.loadPurchaseReceiptError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadPurchaseReceiptResponse = (response) => {
    let receiptList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.purchaseOrderReceiptPageList) &&
      !isEmptyArray(
        response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts,
      )
    ) {
      receiptList =
        response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
      if (receiptList == null) {
        receiptList = new Array();
      }
    }
    this.setState({ receiptList: receiptList });
  };
  loadPurchaseReceiptError = (error) => {
    ShowError("loadPurchaseReceiptError" + error);
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  getFabricStyleList = () => {
    let criteria = new FabricStyleSearchCriteria();
    criteria.companyCode = this.companyCode;
    let requestInput = new RestFabricStyleListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      FabricStyleService.getFabricStylePageList(
        requestInput,
        this.loadFabricStyleListResponse,
        this.loadFabricStyleListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadFabricStyleListResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStylePageList) &&
      !isEmptyArray(response.data.fabricStylePageList.fabricStyles)
    ) {
      const fabricStyle_List = response.data.fabricStylePageList.fabricStyles;
      if (fabricStyle_List == null) {
        fabricStyle_List = new Array();
      }
      this.setState({ fabricStyle_List: fabricStyle_List });
    }
  };
  loadFabricStyleListError = (error) => {
    ShowError(
      this.state.is3PL
        ? "loadItemListError"
        : "loadFabricStyleListError" + error,
    );
  };
  getInventoryAdjustmentList = () => {
    let criteria = new FabricStyleInventoryAdjustmentSearchCriteria();
    criteria.companyCode = this.companyCode;
    let requestInput = new RestFabricStyleInventoryAdjustmentListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      InventoryService.getFabricStyleInventoryAdjustmentPageList(
        requestInput,
        this.loadInventoryAdjustmentListResponse,
        this.loadInventoryAdjustmentListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadInventoryAdjustmentListResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.fabricStyleInventoryAdjustmentPageList) &&
      !isEmptyArray(
        response.data.fabricStyleInventoryAdjustmentPageList
          .fabricStyleInventoryAdjustments,
      )
    ) {
      const adjustmentList =
        response.data.fabricStyleInventoryAdjustmentPageList
          .fabricStyleInventoryAdjustments;
      if (adjustmentList == null) {
        adjustmentList = new Array();
      }
      this.setState({ adjustmentList: adjustmentList });
    }
  };
  loadInventoryAdjustmentListError = (error) => {
    ShowError("loadInventoryAdjustmentListError" + error);
  };
  getSkuBatchInventoryRolls = (code, colorCode) => {
    let searchCriteria = new SKUBatchInventorySearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCode = code;
    searchCriteria.colorCode = colorCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let requestInput = new RestSkuBatchInventoryListRequest();
    requestInput.pageInput = pageInput;
    requestInput.searchCriteria = searchCriteria;
    this.setState({ isLoading: true, loadingText: "Loading...." });
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      InventoryService.getSKUBatchInventoriesForRollBased(
        requestInput,
        this.loadSkuBatchInventoryPageResponse,
        this.loadSkuBatchInventoryPageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadSkuBatchInventoryPageResponse = (response) => {
    const fabricStyleRollList =
      response.data.batchInventoryDataResult.batchInventoryDataBean;
    if (fabricStyleRollList != null) {
      if (fabricStyleRollList.inventoryDataDetails != null) {
        let inventoryRollList = [];
        fabricStyleRollList.inventoryDataDetails.map((list, i) => {
          inventoryRollList.push(list);
        });
        this.setState({
          isLoading: false,
          fabricStyleRollList: fabricStyleRollList,
          inventoryRollList: inventoryRollList,
        });
      } else {
        let errMsg = "No Inventory Available";
        let errList = this.state.error_list;
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadSkuBatchInventoryPageError = (error) => {
    ShowError("loadSkuBatchInventoryPageError" + error);
  };
  openEntryForm = () => {
    let inventoryTransferData = this.state.inventoryTransferData;

    this.setState({
      isInventoryTransferListFormOpen: false,
      isTransferEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowPDFReportButton: false,
      isShowCancelButton: false,
      isShowNodes: true,
      isResetView: false,
      isShowModuleSearchContainer: true,
      isDisabledFields: false,
      isLoadExcelButton: true,
    });

    this.state.isDisabledFields = false;
    this.state.isLoadExcelButton = true;
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isMaintenanceMode: true,
        disabled: false,
        isDisabledFields: false,
      });
      if (this.state.isViewMode) {
        let pageTitle = this.moduleCaption + " - VIEW";
        this.setState({
          isDisabledFields: true,
          disabled: true,
          pageTitle: pageTitle,
        });
      }
    } else {
      this.setState({
        isDisabledFields: true,
        disabled: true,
      });
    }
    if (inventoryTransferData) {
      if (inventoryTransferData.isFetched === true) {
        this.setState({
          isShowSaveButton: false,
          isShowClearCriteriaButton: false,
          isShowClearErrorButton: false,
          isShowBackButton: true,
          // isResetView: false,
          isShowModuleSearchContainer: true,
          isDisabledFields: true,
          isLoadExcelButton: false,
        });
      }
    }
    if (this.state.moduleKeyCode != "NEW") {
      this.setState({ disabled: true });
    }
  };
  closeEntryForm = () => {
    let pageTitle = this.moduleCaption;
    this.setState({
      isInventoryTransferListFormOpen: true,
      isTransferEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFReportButton: false,
      isShowBackButton: false,
      isShowCancelButton: false,
      pageTitle: pageTitle,
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      disabled: false,
      isResetView: false,
      isDisabledFields: false,
      isLoadExcelButton: true,
      isViewMode: false,
      isSpecialViewMode: false,
      inventoryTransferData: new InventoryLocationTransferBean(),
      inventoryTransferLineData: new InventoryLocationTransferLineBean(),
      isMaintenanceMode: false,
    });
  };
  moduleExit = () => {
    if (!this.state.isViewMode && this.isLocked)
      this.unlockInventoryTransfer(this.state.inventoryTransferData.code);

    this.props.onModuleExit();
  };
  moduleCaption = "Inventory Transfer Maintenance";
  addNewEntry = () => {
    let inventoryTransferData = new InventoryLocationTransferBean();
    inventoryTransferData.companyCode = this.companyCode;
    inventoryTransferData.code = "NEW";
    // inventoryTransferData.fromLocationCode = "WH1";
    //Last Changes 
    // if (this.state.isTexco) inventoryTransferData.fromLocationCode = "";
    // else inventoryTransferData.fromLocationCode = DEFAULT_WAREHOUSE;
    if (this.state.isTexco) {
      inventoryTransferData.fromLocationCode =
        ConfigManager.isDefaultWarehouse() || "";
    } else {
      inventoryTransferData.fromLocationCode = DEFAULT_WAREHOUSE;
    }
    let pageTitle = this.moduleCaption + " - NEW";
    if (!isEmptyString(this.state.moduleKeyCode)) {
      inventoryTransferData.code = this.state.moduleKeyCode;
    } else inventoryTransferData.code = "NEW";
    let lineNumber = 1;
    // let lines = inventoryTransferData.transferLines;
    // lines.map((line) => {
    //   if (line.lineNumber > lineNumber) {
    //     lineNumber = line.lineNumber;
    //   }
    // });
    // lineNumber++;

    let inventoryTransferLineData = new InventoryLocationTransferLineBean();
    inventoryTransferLineData.transferCode = inventoryTransferData.code;
    inventoryTransferLineData.lineNumber = lineNumber;
    inventoryTransferLineData.companyCode = this.companyCode;
    inventoryTransferLineData.fromLocationCode =
      inventoryTransferData.fromLocationCode;

    this.setState({
      inventoryTransferData: inventoryTransferData,
      pageTitle: pageTitle,
      inventoryTransferLineData: inventoryTransferLineData,
      isEntryMode: true,
      isListMode: false,
      inventoryTransferLines: [],
      isDisabledFields: false,
      isLoadExcelButton: true,
    });
    this.state.pageTitle = pageTitle;
    this.state.isDisabledFields = false;
    this.state.isLoadExcelButton = true;
    this.state.inventoryTransferData = inventoryTransferData;
    if (this.state.moduleKeyCode != NEW_ENTRY) this.isLocked = true;
    this.openEntryForm();
  };
  onChange = (e) => {
    let tempInventoryTransferData = this.state.inventoryTransferData;
    let tempLineData = this.state.inventoryTransferLineData;
    tempInventoryTransferData[e.target.name] = e.target.value;
    this.setState({
      inventoryTransferData: tempInventoryTransferData,
      inventoryTransferLineData: tempLineData,
    });
  };
  setDefaultValues = (rollSkuNumber) => {
    let list = [];
    if (this.state.rollSkuLookupHandler != null) {
      if (this.state.rollSkuLookupHandler.lookupdata.length > 0) {
        list = this.state.rollSkuLookupHandler.lookupdata;
        this.setRollLineDetails(rollSkuNumber, list);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  onLineChange = (e) => {
    let tempLineData = this.state.inventoryTransferLineData;
    tempLineData[e.target.name] = e.target.value;
    this.setState({
      inventoryTransferLineData: tempLineData,
    });
  };

  validateLine = (inventoryTransferLineData) => {
    let isValidatelLine = false;
    let err_list = [];
    let errorMessage = "";
    if (inventoryTransferLineData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(inventoryTransferLineData.fabricStyleCode)) {
        let errMsg = "";
        if (!this.state.is3PL) {
          errMsg = "Fabric Style is required!";
        } else {
          errMsg = "Item is required!";
        }
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(inventoryTransferLineData.fabricStyleColorCode)) {
        let errMsg = "ColorCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(inventoryTransferLineData.rollSkuNumber)) {
        let errMsg = this.state.is3PL
          ? "Inventory# is Required"
          : "RollSkuNumber is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(inventoryTransferLineData.transferQuantity)) {
        let errMsg = "TransferQty is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (
        isEmptyString(inventoryTransferLineData.fromLocationCode) ||
        isEmptyString(inventoryTransferLineData.toLocationCode)
      ) {
        let errMsg = "location is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidatelLine = false;
      this.setState({ errorList: err_list });

      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isShowPopupAlert: false,
      });
    } else {
      isValidatelLine = true;
      this.setState({ isShowAlert: false, isShowPopupAlert: false });
    }
    return isValidatelLine;
  };
  addOrUpdateLineChange = (e) => {
    let inventoryTransferLineData = this.state.inventoryTransferLineData;
    let inventoryTransferData = this.state.inventoryTransferData;
    //let inventoryTransferLines = this.state.inventoryTransferLines;
    let inventoryTransferLinesList =
      this.state.inventoryTransferData.transferLines;
    let isValidLine = false;
    isValidLine = this.validateLine(inventoryTransferLineData);
    if (isValidLine) {
      let isLineFound = false;
      inventoryTransferLinesList.map((line, i) => {
        if (line.lineNumber == inventoryTransferLineData.lineNumber) {
          inventoryTransferLineData.lineNumber = line.lineNumber;
          inventoryTransferLinesList[i] = inventoryTransferLineData;
          isLineFound = true;
        }
      });
      if (!isLineFound)
        inventoryTransferLinesList.push(inventoryTransferLineData);
      if (inventoryTransferLineData.transferQuantity != 0) {
        inventoryTransferData.transferLines = inventoryTransferLinesList;
        this.setState({
          inventoryTransferLines: inventoryTransferLinesList,
          inventoryTransferData: inventoryTransferData,
          inventoryTransferLineData: new InventoryLocationTransferLineBean(),
          isShowColorLookup: false,
          isShowRollSkuLookup: false,
        });
        this.clearLineValues();
      } else {
        let errMsg = "Invalid TransferQty";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  clearLineValues = () => {
    if (this.fabricStyleColorCodeRef.current != null) {
      this.fabricStyleColorCodeRef.current.clear();
    }
    if (this.fabricStyleCodeRef.current != null) {
      this.fabricStyleCodeRef.current.clear();
      this.fabricStyleCodeRef.current.focus();
    }
    let inventoryTransferData = this.state.inventoryTransferData;
    let lineNumber = 0;
    let lines = inventoryTransferData.transferLines;
    lines.map((line) => {
      if (line.lineNumber > lineNumber) {
        lineNumber = line.lineNumber;
      }
    });
    lineNumber++;
    let inventoryTransferLineData = new InventoryLocationTransferLineBean();
    inventoryTransferLineData.transferCode = inventoryTransferData.code;
    inventoryTransferLineData.lineNumber = lineNumber;
    inventoryTransferLineData.companyCode = this.companyCode;
    inventoryTransferLineData.fromLocationCode =
      inventoryTransferData.fromLocationCode;
    inventoryTransferLineData.toLocationCode =
      inventoryTransferData.toLocationCode;
    this.setState({
      inventoryTransferData: inventoryTransferData,
      inventoryTransferLineData: inventoryTransferLineData,
      isShowColorLookup: false,
      isShowRollSkuLookup: false,
      rollSkuLookupHandler: null,
    });
  };
  getLineDetails = (rowData) => {
    let lineDetail = { ...rowData };
    this.setState({
      inventoryTransferLineData: lineDetail,
      isShowColorLookup: true,
    });
    if (lineDetail.isFetched)
      this.setState({
        isShowColorLookup: false,
      });
  };
  setRollLineDetails = (val, binInventoryList) => {
    let inventoryTransferLineData = this.state.inventoryTransferLineData;
    binInventoryList.map((list, i) => {
      if (list.rollSkuNumber == val) {
        inventoryTransferLineData.rollSkuNumber = list.rollSkuNumber;
        inventoryTransferLineData.vendorBatchNumber = list.vendorBatchNumber;
        inventoryTransferLineData.boxNumber = list.boxNumber;
        inventoryTransferLineData.rollNumber = list.rollNumber;
        inventoryTransferLineData.transferQuantity = list.onHandQuantity;
        inventoryTransferLineData.aisleInfoText = list.aisleInfoText;
        inventoryTransferLineData.skuNumber = list.skuNumber;
        inventoryTransferLineData.uomCode = list.uomCode;
      }
    });
    this.setState({
      inventoryTransferLineData: inventoryTransferLineData,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadRollLines = () => {
    let inventoryTransferData = this.state.inventoryTransferData;
    let roll_Lines = this.state.roll_Lines;
    let rollLines = this.state.inventoryTransferLines;
    if (!isEmptyArray(roll_Lines)) {
      var lineNumber = this.getTransferDataMaxLineNumber();
      for (let line of roll_Lines) {
        if (line.onHandQuantity <= 0) continue;
        let inventoryTransferLineData = new InventoryLocationTransferLineBean();
        inventoryTransferLineData.companyCode = this.companyCode;
        inventoryTransferLineData.transferCode = inventoryTransferData.code;
        inventoryTransferLineData.lineNumber = ++lineNumber;
        inventoryTransferLineData.fabricStyleCode = line.fabricStyleCode;
        inventoryTransferLineData.fabricStyleShortName = line.fabricStyleName;
        inventoryTransferLineData.fabricStyleColorCode =
          line.fabricStyleColorCode;
        inventoryTransferLineData.rollNumber = line.rollNumber;
        inventoryTransferLineData.rollSkuNumber = line.rollSkuNumber;
        inventoryTransferLineData.skuNumber = line.skuNumber;
        inventoryTransferLineData.uomCode = line.uomCode;
        inventoryTransferLineData.vendorBatchNumber = line.vendorBatchNumber;
        inventoryTransferLineData.widthCode = line.widthCode;
        inventoryTransferLineData.boxNumber = line.boxNumber;
        inventoryTransferLineData.transferQuantity = line.onHandQuantity;
        inventoryTransferLineData.aisleInfoText = line.aisleInfoText;
        inventoryTransferLineData.fromLocationCode =
          inventoryTransferData.fromLocationCode;
        inventoryTransferLineData.toLocationCode =
          inventoryTransferData.toLocationCode;
        rollLines.push(inventoryTransferLineData);
      }
      inventoryTransferData.transferLines = rollLines;
      this.setState({
        inventoryTransferLines: rollLines,
        inventoryTransferData: inventoryTransferData,
      });
      this.clearLineValues();
    } else {
      let errMsg = "Inventory Not Available";
      let errorList = [];
      errorList.push(errMsg);
      this.setState({
        alertMessage: errorList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteTransferLines = (rowData) => {
    let inventoryTransferData = this.state.inventoryTransferData;
    let lineData = inventoryTransferData.transferLines;
    if (rowData.isFetched == false) {
      var index = lineData.indexOf(rowData);
      if (index > -1) {
        lineData.splice(index, 1);
      }
    } else {
      let errMsg = "Already Added Lines Cannot be Removed";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.reArrangeInventoryTransferLineNumbers(lineData);
    this.setState({ inventoryTransferData: inventoryTransferData });
  };
  reArrangeInventoryTransferLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
    this.clearLineValues();
  };
  getTransferDataMaxLineNumber() {
    let maxLineNumber = 0;
    let rolls = this.state.inventoryTransferData.transferLines;
    if (rolls.length > 0)
      rolls.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  save = () => {
    this.saveInventoryTransfer();
  };
  saveInventoryTransfer = () => {
    let inventoryTransferData = this.state.inventoryTransferData;
    if (
      SecurityAccessManager.InventoryTransferMaintenanceCreate_IsAccessible()
    ) {
      InventoryService.createInventoryLocationTransfer(
        inventoryTransferData,
        this.saveInventoryTransferResponse,
        this.saveInventoryTransferError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  saveInventoryTransferResponse = (response) => {
    this.handleresponse(response.data);
    const inventoryTransferBean = response.data.inventoryLocationTransferBean;
    if (inventoryTransferBean != null) {
      let pageTitle = this.moduleCaption + " - EDIT";
      this.setState({
        inventoryTransferData: inventoryTransferBean,
        pageTitle: pageTitle,
      });
      if (this.state.moduleKeyCode != NEW_ENTRY) {
        this.unlockInventoryTransfer(inventoryTransferBean.code);
      }
      this.editInventoryTransfer(inventoryTransferBean.code);
    }
  };
  saveInventoryTransferError = (error) => {
    ShowError("saveInventoryTransferError :" + error);
  };
  editInventoryTransfer = (transferCode) => {
    let readrequest = new RestReadRequest();
    readrequest.companyCode = this.companyCode;
    readrequest.code = transferCode;
    let isLockRequired = "NEW" === transferCode ? false : true;
    // if (isUpdateReloadflag) isLockRequired = false;
    readrequest.isLockRequired = isLockRequired;
    this.setState({ isLoading: true });
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      InventoryService.initInventoryLocationTransferModule(
        readrequest,
        this.readInventoryTransferResponse,
        this.readInventoryTransferError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readInventoryTransferResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.inventoryLocationTransferResponseBean != null) {
      if (response.data.inventoryLocationTransferResponseBean.errors != null) {
        response.data.inventoryLocationTransferResponseBean.errors.map(
          (err) => {
            errMsg = err.messageDescription;
          },
        );
      }
      if (
        errMsg !=
        " Inventory Location Transfer " +
          this.state.moduleKeyCode +
          " Not Read Sucessfully "
      ) {
        this.showErrorMessage(
          response.data.inventoryLocationTransferResponseBean,
        );
      }
    }

    if (response.data.inventoryLocationTransferResponseBean != null) {
      if (
        response.data.inventoryLocationTransferResponseBean
          .inventoryLocationTransferBean != null
      ) {
        let transferBean =
          response.data.inventoryLocationTransferResponseBean
            .inventoryLocationTransferBean;
        if (transferBean != null) {
          let pageTitle = this.moduleCaption + " - EDIT";
          let moduleKeyCode = transferBean.code;
          this.state.inventoryTransferData = transferBean;
          this.setState({
            inventoryTransferData: transferBean,
            pageTitle: pageTitle,
            isLoading: false,
            moduleKeyCode: moduleKeyCode,
          });
          this.isLocked = true;
          this.openEntryForm();
        }
      } else {
        this.addNewEntry();
      }
    }
    this.setState({ isLoading: false });
  };
  readInventoryTransferError = (error) => {
    ShowError("readInventoryTransferError" + error);
  };
  back = () => {
    this.closeEntryForm();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  unlockInventoryTransfer = (code) => {
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = code;
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      InventoryService.unLockInventoryLocationTransferCode(
        request,
        this.unlockInventoryTransferResponse,
        this.unlockInventoryTransferError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unlockInventoryTransferResponse = (response) => {
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        this.isLocked = false;
      } else {
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockInventoryTransferError = (error) => {
    ShowError("Error : ", error);
  };
  getModuleListView = () => {
    let inventoryTransferData = this.state.inventoryTransferData;
    if (inventoryTransferData.code === "NEW") {
      this.closeEntryForm();
      this.loadInventoryTransferPage();
    } else {
      if (!this.state.isViewMode && this.isLocked)
        this.unlockInventoryTransfer(inventoryTransferData.code);

      this.closeEntryForm();
      this.loadInventoryTransferPage();
    }
  };
  resetView = () => {
    let inventoryTransfer_Data = this.state.inventoryTransferData;
    this.state.isReseted = true;

    if (!this.state.isViewMode && this.isLocked)
      this.unlockInventoryTransfer(inventoryTransfer_Data.code);

    let inventoryTransferData = new InventoryLocationTransferBean();
    this.setState({
      inventoryTransferData: inventoryTransferData,
      isResetModule: true,
      moduleKeyCode: "NEW",
      disabled: false,
      isFocusLookup: true,
      isShowColorLookup: false,
      isShowRollSkuLookup: false,
      isDisabledFields: false,
      isLoadExcelButton: true,
      isShowAutoCompleteFromLocationList: false,
      fromLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteToLocationList: false,
      toLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteDocumentList: false,
      documentPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteTransferReasonList: false,
      transferReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteColorList: false,
      colorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRollSkutList: false,
      rollSkuPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjustmentList: false,
      adjustmentPageListForAutoCompleteList: new Array(),
      isShowAutoCompletepurchaseReceiptList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
    });
    this.state.inventoryTransferData = new InventoryLocationTransferBean();
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  moduleExit = () => {
    let inventoryTransferData = this.state.inventoryTransferData;
    if (inventoryTransferData.code === "NEW") {
      this.props.onModuleExit();
    } else {
      if (!this.state.isViewMode)
        this.unlockInventoryTransfer(inventoryTransferData.code);

      this.props.onModuleExit();
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  selectButtonClick = (e) => {
    this.editInventoryTransfer(this.state.moduleKeyCode);
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  uploadExcelFile = (e) => {
    let file = e.target.files[0];
    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);
    this.setState({ fileName: fileName });
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      InventoryService.inventoryExcelUpload(
        formData,
        this.uploadInventoryExcelResponse,
        this.uploadInventoryExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  uploadInventoryExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getExcelData();
      }
    }
  };
  uploadInventoryExcelError = (error) => {};
  getExcelData = () => {
    let request = new RestInventoryEntityRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.inventoryTransferData.code;
    request.entityCode = this.state.fileName;
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      InventoryService.getInventoryInputFromExcel(
        request,
        this.getInventoryExcelResponse,
        this.getInventoryExcelError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getInventoryExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null) {
      if (response.data.einput != null) {
        let excelInventoryList = response.data.einput.lines;
        for (let lines of excelInventoryList) {
          if (lines.rollSkuNumber > 0) {
            this.setState({
              excelInventoryList: excelInventoryList,
              isShowExcelDataPopup: true,
            });
          } else {
            this.setState({
              excelIncompleteInventoryList: lines,
              isShowExcelDataPopup: true,
            });
          }
        }
      }
    }
  };
  getInventoryExcelError = (error) => {
    ShowError("error :", error);
  };
  selectAllExcelLine = (e) => {
    if (e.detail <= 1) {
      let list = this.state.excelInventoryList;
      list.map((line, i) => {
        line.isActive = true;
      });
      this.setState({ selectedExcelDataList: list });
    }
  };
  unSelectAllExcelLine = (e) => {
    if (e.detail <= 1) {
      let list = this.state.excelInventoryList;
      list.map((line, i) => {
        line.isActive = false;
      });
      this.state.selectedExcelDataList = [];
      this.setState({ selectedExcelDataList: [] });
    }
  };
  excelDataLineCheck = (e, rowData) => {
    let selectedLine = this.state.selectedExcelDataList;
    rowData.isActive = e.target.value;
    if (rowData.isActive === true) {
      selectedLine.push(rowData);
      this.setState({ selectedExcelDataList: selectedLine });
    } else {
      let selectedExcelDataList = this.state.selectedExcelDataList;
      let list = [];
      for (let data of selectedExcelDataList) {
        if (data.isActive != rowData.isActive) {
          list.push(data);
          this.setState({ selectedExcelDataList: list });
        }
      }
    }
  };
  excelListColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", true)
        .setStyleDetails("left", "", "", "wt-2", "wt-2")
        .setInputDetails(
          false,
          false,
          true,
          null,
          this.excelDataLineCheck,
          null,
        ),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleName",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "colorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      // .setClickDetails(true, false, this.lnkCustomerModule,null )
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot#", "lotNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Box#", "boxNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Seq#" : "Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uom", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "binLocation", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty#", "quantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );

    return columns;
  };
  excelListColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null,
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.excelDataLineCheck,
        ),
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode"),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode",
        ),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Color", "colorCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Lot#", "lotNumber"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Box#", "boxNumber"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Roll#", "rollNumber"),
    );
    columnList.push(new DataGridColumnDefinition().setDetails("UOM", "uom"));
    columnList.push(
      new DataGridColumnDefinition().setDetails("Location", "binLocation"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("OnHandQty#", "quantity", 1),
    );
    return columnList;
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowExcelDataPopup: isShowPopup,
      isShowReceiptPopup: isShowPopup,
      isShowAdjustmentPopup: isShowPopup,
    });
  };
  addExcelDataLine = (e) => {
    if (e.detail == 1) {
      let selectedExcelDataList = this.state.selectedExcelDataList;
      let inventoryTransferData = this.state.inventoryTransferData;
      let rollLines = this.state.inventoryTransferLines;
      if (selectedExcelDataList != null) {
        var lineNumber = this.getTransferDataMaxLineNumber();
        for (let list of selectedExcelDataList) {
          let inventoryTransferLineData =
            new InventoryLocationTransferLineBean();
          inventoryTransferLineData.companyCode = this.companyCode;
          inventoryTransferLineData.transferCode = inventoryTransferData.code;
          inventoryTransferLineData.lineNumber = ++lineNumber;
          inventoryTransferLineData.fabricStyleCode = list.fabricStyleCode;
          inventoryTransferLineData.fabricStyleShortName = list.fabricStyleName;
          inventoryTransferLineData.fabricStyleColorCode = list.colorCode;
          inventoryTransferLineData.rollNumber = list.rollNumber;
          inventoryTransferLineData.rollSkuNumber = list.rollSkuNumber;
          inventoryTransferLineData.uomCode = list.uom;
          inventoryTransferLineData.vendorBatchNumber = list.lotNumber;
          inventoryTransferLineData.widthCode = list.widthCode;
          inventoryTransferLineData.boxNumber = list.boxNumber;
          inventoryTransferLineData.aisleInfoText = list.binLocation;
          inventoryTransferLineData.skuNumber = list.skuNumber;
          inventoryTransferLineData.transferQuantity = list.quantity;
          inventoryTransferLineData.fromLocationCode =
            inventoryTransferData.fromLocationCode;
          inventoryTransferLineData.toLocationCode =
            inventoryTransferData.toLocationCode;
          rollLines.push(inventoryTransferLineData);
        }
        inventoryTransferData.transferLines = rollLines;
      }
      this.setState({
        inventoryTransferLines: rollLines,
        inventoryTransferData: inventoryTransferData,
        excelInventoryList: [],
        selectedExcelDataList: [],
        isShowExcelDataPopup: false,
      });
      this.clearLineValues();
    }
  };
  fromLocationOnChange = (e) => {
    let fromLocationCode = e.target.value;
    this.state.isShowAutoCompleteFromLocationList = true;
    let tempCriteria = this.state.inventoryTransferData;
    let showAutoCompleteList = this.state.isShowAutoCompleteFromLocationList;
    if (isEmpty(fromLocationCode)) {
      this.state.isShowAutoCompleteFromLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFromLocationList;
      let tempCriteria = this.state.inventoryTransferData;
      tempCriteria.fromLocationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        inventoryTransferData: tempCriteria,
        fromLocationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fromLocationCode" &&
      showAutoCompleteList === true &&
      fromLocationCode !== ""
    ) {
      this.readFromLocationBySearchString(e.target.value);
    }
    this.readFromLocation(fromLocationCode);
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ inventoryTransferData: tempCriteria });
  };

  fromLocationEnterKeyEventHandler = (e) => {
    let fromLocationCode = e.target.value;
    this.readFromLocation(fromLocationCode);
    this.state.isShowAutoCompleteFromLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteFromLocationList;
    this.setState({
      fromLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  toLocationOnChange = (e) => {
    let toLocationCode = e.target.value;
    this.state.isShowAutoCompleteToLocationList = true;
    let tempCriteria = this.state.inventoryTransferData;
    let showAutoCompleteList = this.state.isShowAutoCompleteToLocationList;
    if (isEmpty(toLocationCode)) {
      this.state.isShowAutoCompleteToLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteToLocationList;
      let tempCriteria = this.state.inventoryTransferData;
      tempCriteria.toLocationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        inventoryTransferData: tempCriteria,
        toLocationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "toLocationCode" &&
      showAutoCompleteList === true &&
      toLocationCode !== ""
    ) {
      this.readToLocationBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.readToLocation(toLocationCode);
    this.setState({ inventoryTransferData: tempCriteria });
  };
  toLocationEnterKeyEventHandler = (e) => {
    let toLocationCode = e.target.value;
    this.readToLocation(toLocationCode);
    this.state.isShowAutoCompleteToLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteToLocationList;
    this.setState({
      toLocationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  readFromLocation = (fromLocationCode) => {
    let tempCriteria = this.state.inventoryTransferData;
    let locationBean = null;
    let locationData = null;
    if (
      tempCriteria.toLocationCode.toLowerCase() ==
      fromLocationCode.toLowerCase()
    ) {
      let errMsg =
        "Unable to move to same Location please provide differernt Location";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      this.state.warehouses.map((ln) => {
        if (ln.code === fromLocationCode) {
          locationBean = ln;
          locationData = new BaseBean();
          locationData.code = ln.code;
          locationData.description = ln.description;
        }
      });
      if (!isEmpty(locationBean)) {
        tempCriteria.fromLocationCode = locationBean.code;
        this.state.isShowAutoCompleteFromLocationList = false;
        let showAutoCompleteList =
          this.state.isShowAutoCompleteFromLocationList;
        this.setState({
          inventoryTransferData: tempCriteria,
          isShowAutoCompleteFromLocationList: showAutoCompleteList,
        });
      }
      this.setState({ locationData: locationData });
      let tempLineData = this.state.inventoryTransferLineData;
      let fromLocationData = null;
      fromLocationData = fromLocationCode;
      tempLineData.fromLocationCode = fromLocationData;
      tempCriteria.transferLines.map((list, i) => {
        list.fromLocationCode = fromLocationData;
      });
      this.setState({
        inventoryTransferLineData: tempLineData,
        inventoryTransferData: tempCriteria,
      });
    }
  };
  readToLocation = (toLocationCode) => {
    let tempCriteria = this.state.inventoryTransferData;
    let locationBean = null;
    let locationData = null;
    if (
      tempCriteria.fromLocationCode.toLowerCase() ==
      toLocationCode.toLowerCase()
    ) {
      let errMsg =
        "Unable to move to same Location please provide differernt Location";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      this.state.warehouses.map((ln) => {
        if (ln.code === toLocationCode) {
          locationBean = ln;
          locationData = new BaseBean();
          locationData.code = ln.code;
          locationData.description = ln.description;
        }
      });
      if (!isEmpty(locationBean)) {
        tempCriteria.toLocationCode = locationBean.code;
        this.state.isShowAutoCompleteToLocationList = false;
        let showAutoCompleteList = this.state.isShowAutoCompleteToLocationList;
        this.setState({
          inventoryTransferData: tempCriteria,
          isShowAutoCompleteToLocationList: showAutoCompleteList,
        });
      }
      this.setState({ locationData: locationData });
      let tempLineData = this.state.inventoryTransferLineData;
      let toLocationData = null;
      toLocationData = toLocationCode;
      tempLineData.toLocationCode = toLocationData;
      tempCriteria.transferLines.map((list, i) => {
        list.toLocationCode = toLocationData;
      });
      this.setState({
        inventoryTransferData: tempCriteria,
        inventoryTransferLineData: tempLineData,
      });
    }
  };
  readFromLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fromLocationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readToLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((location) => {
        let locationBean = {
          code: location.code,
          description: location.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      toLocationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  displayFromLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteFromLocationList: isShowAutoCompleteList,
    });
  };
  displayToLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteToLocationList: isShowAutoCompleteList,
    });
  };
  onDocumentChange = (e) => {
    let documentType = e.target.value;
    this.state.isShowAutoCompleteDocumentList = true;
    let tempCriteria = this.state.inventoryTransferData;
    let showAutoCompleteList = this.state.isShowAutoCompleteDocumentList;
    if (isEmpty(documentType)) {
      this.state.isShowAutoCompleteDocumentList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteDocumentList;
      let criteria = this.state.inventoryTransferData;
      criteria.documentType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteDocumentList: showAutoCompleteList,
        inventoryTransferData: criteria,
        documentPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "documentType" &&
      showAutoCompleteList === true &&
      documentType !== ""
    ) {
      this.readDocumentBySearchString(e.target.value);
    }
    tempCriteria["documentType"] = e.target.value;
    this.readDocument(documentType);
    this.setState({ inventoryTransferData: tempCriteria });
  };
  documentEnterKeyEventHandler = (e) => {
    let documentType = e.target.value;
    this.readDocument(e.target.value);
    this.setState({
      documentPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteDocumentList: false,
    });
  };

  readDocument = (documentType) => {
    let tempCriteria = this.state.inventoryTransferData;
    tempCriteria["documentType"] = documentType;
    let documentType_List = this.state.documentTypes;
    documentType_List.map((documentType) => {
      if (documentType.code == documentType) {
        tempCriteria["documentType"] = documentType.code;
        this.state.isShowAutoCompleteDocumentList = false;
        let isShowAutoCompleteDocumentList =
          this.state.isShowAutoCompleteDocumentList;
        this.setState({
          isShowAutoCompleteDocumentList: isShowAutoCompleteDocumentList,
        });
      }
    });
    this.setState({ inventoryTransferData: tempCriteria });
  };
  readDocumentBySearchString(searchString) {
    let documentTypeData = this.state.documentTypes;
    let simpleAutoCompleteList = new Array();
    if (documentTypeData.length > 0 && documentTypeData != null) {
      documentTypeData.map((documentTypes) => {
        let simpleItemBean = {
          code: documentTypes.code,
          description: documentTypes.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletedocumentLists) =>
        simpleAutoCompletedocumentLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ documentPageListForAutoCompleteList: filteredSuggestions });
  }

  displayAutoCompleteDocumentList = (isShowAutoCompleteDocumentList) => {
    this.setState({
      isShowAutoCompleteDocumentList: isShowAutoCompleteDocumentList,
    });
  };
  transferReasonOnChange = (e) => {
    let transferReason = e.target.value;
    this.state.isShowAutoCompleteTransferReasonList = true;
    let tempCriteria = this.state.inventoryTransferData;
    let showAutoCompleteList = this.state.isShowAutoCompleteTransferReasonList;
    if (isEmpty(transferReason)) {
      this.state.isShowAutoCompleteTransferReasonList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompleteTransferReasonList;
      let criteria = this.state.inventoryTransferData;
      criteria.transferReason = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteTransferReasonList: showAutoCompleteList,
        inventoryTransferData: criteria,
        transferReasonPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "transferReason" &&
      showAutoCompleteList === true &&
      transferReason !== ""
    ) {
      this.readTransferReasonBySearchString(e.target.value);
    }
    tempCriteria["transferReason"] = e.target.value;
    this.readTransferReason(transferReason);
    this.setState({ inventoryTransferData: tempCriteria });
  };
  transferReasonEnterKeyEventHandler = (e) => {
    let transferReason = e.target.value;
    this.readTransferReason(e.target.value);
    this.setState({
      transferReasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteTransferReasonList: false,
    });
  };
  readTransferReason = (transferReason) => {
    let tempCriteria = this.state.inventoryTransferData;
    tempCriteria["transferReason"] = transferReason;
    let temp_Criteria = this.state.inventoryTransferReasons;
    temp_Criteria.map((transferReason) => {
      if (transferReason.code == transferReason) {
        tempCriteria["transferReason"] = transferReason.code;
        this.state.isShowAutoCompleteTransferReasonList = false;
        let isShowAutoCompleteTransferReasonList =
          this.state.isShowAutoCompleteTransferReasonList;
        this.setState({
          isShowAutoCompleteTransferReasonList:
            isShowAutoCompleteTransferReasonList,
        });
      }
    });
    this.setState({ inventoryTransferData: tempCriteria });
  };
  readTransferReasonBySearchString(searchString) {
    let transferReasonData = this.state.inventoryTransferReasons;
    let simpleAutoCompleteList = new Array();
    if (transferReasonData.length > 0 && transferReasonData != null) {
      transferReasonData.map((inventoryTransferReasons) => {
        let simpleItemBean = {
          code: inventoryTransferReasons.code,
          description: inventoryTransferReasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      transferReasonPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  displayAutoCompleteTransferReasonList = (
    isShowAutoCompleteTransferReasonList,
  ) => {
    this.setState({
      isShowAutoCompleteTransferReasonList:
        isShowAutoCompleteTransferReasonList,
    });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.isShowAutoCompleteFabricList = true;
    let tempCriteria = this.state.inventoryTransferLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.isShowAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
      let criteria = this.state.inventoryTransferLineData;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleShortName = "";
      criteria.fabricStyleColorCode = "";
      criteria.rollSkuNumber = 0;
      criteria.rollNumber = "";
      criteria.boxNumber = "";
      criteria.vendorBatchNumber = "";
      criteria.uomCode = "";
      criteria.transferQuantity = 0;
      criteria.widthCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteFabricList: showAutoCompleteList,
        inventoryTransferLineData: criteria,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        isShowRollSkuLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
      // this.readSelectedFabricStyle(fabricStyleCode);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ inventoryTransferLineData: tempCriteria });
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.readSelectedFabricStyle(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: false,
    });
  };
  displayAutoCompleteFabricList = (showAutoCompleteFabricList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteFabricList });
  };

  readSelectedFabricStyle = (fabricStyleCode) => {
    let requestInput = new RestReadRequest();
    requestInput.companyCode = this.companyCode;
    requestInput.code = fabricStyleCode;
    requestInput.isLockRequired = false;
    requestInput.loadChildren = true;
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      FabricStyleService.readFabricStyle(
        requestInput,
        this.readFabricStyleResponse,
        this.readFabricStyleError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readFabricStyleResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.fabricStyle)) {
      let fabricStyleBean = response.data.fabricStyle;
      let inventoryTransferLineData = this.state.inventoryTransferLineData;
      this.state.currentFabricStyle = fabricStyleBean;
      if (fabricStyleBean) {
        inventoryTransferLineData.fabricStyleCode = fabricStyleBean.code;
        inventoryTransferLineData.fabricStyleShortName =
          fabricStyleBean.description;
        inventoryTransferLineData.fabricStyleColorCode = "";
        inventoryTransferLineData.widthCode = fabricStyleBean.width;
        inventoryTransferLineData.uomConversionRate = 1;
        inventoryTransferLineData.uomCode = fabricStyleBean.inventoryUomCode;
        inventoryTransferLineData.fabricStyleColorCode = "";
        inventoryTransferLineData.rollSkuNumber = 0;
        inventoryTransferLineData.uomCode = "";
        inventoryTransferLineData.rollNumber = "";
        inventoryTransferLineData.boxNumber = "";
        inventoryTransferLineData.vendorBatchNumber = "";
        inventoryTransferLineData.transferQuantity = 0;
        let colors = fabricStyleBean.colors;
        if (!isEmpty(colors)) {
          if (colors.length == 1) {
            inventoryTransferLineData.fabricStyleColorCode =
              colors[0].fabricStyleColorCode;
            this.fabricStyleColorSelected(
              inventoryTransferLineData.fabricStyleColorCode,
            );

            this.setState({
              isShowColorLookup: false,
            });
          } else {
            let finalColorList = [];
            colors.map((ent) => {
              let colorBean = new BaseBean();
              colorBean.code = ent.fabricStyleColorCode;
              colorBean.description = ent.fabricStyleColorName;
              finalColorList.push(colorBean);
            });
            this.setState({
              colorLookupHandler: null,
              isShowRollSkuLookup: false,
              finalColorList: finalColorList,
            });
            if (finalColorList != null) {
              let colorLookupHandler = new GenericAttributeLookupHandler(
                finalColorList,
                "Color",
              );
              this.setState({
                colorLookupHandler: colorLookupHandler,
                isShowColorLookup: true,
              });
            }
          }
        }
        // inventoryTransferLineData.fabricStyleCode = fabricStyleBean.code;
      }
      this.setState({
        currentFabricStyle: fabricStyleBean,
        inventoryTransferLineData: inventoryTransferLineData,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  readFabricStyleError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError(
      this.state.is3PL
        ? "readItemPageError"
        : "readFabricStylePageError" + error,
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.readByFabricCodeResponseError,
    );
  }
  readByFabricCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  colorOnChange = (e) => {
    let fabricStyleColorCode = e.target.value;
    this.state.isShowAutoCompleteColorList = true;
    let tempCriteria = this.state.inventoryTransferLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteColorList;
    if (isEmpty(fabricStyleColorCode)) {
      this.state.isShowAutoCompleteColorList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteColorList;
      let criteria = this.state.inventoryTransferLineData;
      criteria.fabricStyleColorCode = "";
      criteria.rollSkuNumber = 0;
      criteria.rollNumber = "";
      criteria.boxNumber = "";
      criteria.vendorBatchNumber = "";
      criteria.uomCode = "";
      criteria.transferQuantity = 0;
      let suggestion = [];
      this.setState({
        isShowAutoCompleteColorList: showAutoCompleteList,
        inventoryTransferLineData: criteria,
        colorPageListForAutoCompleteList: suggestion,
        isShowRollSkuLookup: false,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteList === true &&
      fabricStyleColorCode !== ""
    ) {
      this.readFabricColorBySearchString(e.target.value);
      // this.fabricStyleColorSelected(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ inventoryTransferLineData: tempCriteria });
  };
  colorEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading Color",
    });
    this.fabricStyleColorSelected(e.target.value);
    this.setState({
      colorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteColorList: false,
    });
  };
  displayAutoCompleteColorList = (isShowAutoCompleteColorList) => {
    this.setState({
      isShowAutoCompleteColorList: isShowAutoCompleteColorList,
    });
  };
  readFabricColorBySearchString(searchString) {
    let fabricStyle = this.state.currentFabricStyle;
    let criteria = this.state.inventoryTransferLineData;
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.finalColorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      colorPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.currentFabricStyle;
    let criteria = this.state.inventoryTransferLineData;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    criteria.fabricStyleColorCode = colorCode;
    criteria.rollSkuNumber = 0;
    criteria.uomCode = "";
    criteria.rollNumber = "";
    criteria.boxNumber = "";
    criteria.vendorBatchNumber = "";
    criteria.transferQuantity = 0;
    if (!isEmpty(skuBean)) {
      criteria.skuNumber = skuBean.skuNumber;
      let fabricStyleCode = skuBean.fabricStyleCode;
      let colorCode = skuBean.fabricStyleColorCode;
      let rollSkuLookupHandler = new RollSkuLookupHandler(
        this.companyCode,
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        fabricStyleCode,
        colorCode,
      );
      let lookup_data = [];
      let lookupdata = rollSkuLookupHandler.lookupdata;
      lookupdata.map((data) => {
        lookup_data.push(data);
      });

      this.setState({
        rollSkuLookupHandler: rollSkuLookupHandler,
        lookup_data: lookup_data,
        isShowRollSkuLookup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.state.inventoryTransferLineData = criteria;

    this.setState({
      inventoryTransferLineData: criteria,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  rollSkuOnChange = (e) => {
    let rollSkuNumber = e.target.value;
    this.state.isShowAutoCompleteRollSkutList = true;
    let tempCriteria = this.state.inventoryTransferLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteRollSkutList;
    if (isEmpty(rollSkuNumber)) {
      this.state.isShowAutoCompleteRollSkutList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteRollSkutList;
      let criteria = this.state.inventoryTransferLineData;
      criteria.rollSkuNumber = 0;
      criteria.rollNumber = "";
      criteria.boxNumber = "";
      criteria.vendorBatchNumber = "";
      criteria.uomCode = "";
      criteria.transferQuantity = 0;
      let suggestion = [];
      this.setState({
        isShowAutoCompleteRollSkutList: showAutoCompleteList,
        inventoryTransferLineData: criteria,
        rollSkuPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "rollSkuNumber" &&
      showAutoCompleteList === true &&
      rollSkuNumber !== ""
    ) {
      this.readRollSkuBySearchString(e.target.value);
    }
    tempCriteria["rollSkuNumber"] = e.target.value;
    // this.readRollSku(rollSkuNumber);
    this.setState({ inventoryTransferLineData: tempCriteria });
  };
  rollSkuEnterKeyEventHandler = (e) => {
    let rollSkuNumber = e.target.value;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading...",
    });
    this.readRollSku(e.target.value);
    this.setState({
      rollSkuPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteRollSkutList: false,
    });
  };
  readRollSku = (rollSkuNumber) => {
    let tempCriteria = this.state.inventoryTransferLineData;
    tempCriteria["rollSkuNumber"] = rollSkuNumber;
    let lookupData = [];
    let rollSkuLookupHandler = this.state.rollSkuLookupHandler.lookupdata;
    rollSkuLookupHandler.map((sku) => {
      lookupData.push(sku);
    });
    lookupData.map((rollSkuNumber) => {
      if (rollSkuNumber.code == rollSkuNumber) {
        tempCriteria["rollSkuNumber"] = rollSkuNumber.code;
        this.state.isShowAutoCompleteRollSkutList = false;
        let isShowAutoCompleteRollSkutList =
          this.state.isShowAutoCompleteRollSkutList;
        this.setState({
          isShowAutoCompleteRollSkutList: isShowAutoCompleteRollSkutList,
        });
      }
    });
    this.setDefaultValues(rollSkuNumber);
    this.setState({ inventoryTransferLineData: tempCriteria });
  };

  readApplyRollResponseError = (error) => {
    ShowError("Error : ", error);
  };
  readApplyRollSkuResponse = (response) => {
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.skuBatchInventoryPageList) &&
      !isEmptyArray(response.data.skuBatchInventoryPageList.skuBatchInventories)
    ) {
      let listData =
        response.data.skuBatchInventoryPageList.skuBatchInventories;
      let rollSkuData = [];
      listData.map((obj) => {
        if (obj.onHandQuantity > 0) {
          rollSkuData.push(obj);
        }
      });
      let simpleAutoCompleteList = new Array();
      if (rollSkuData.length > 0 && rollSkuData != null) {
        rollSkuData.map((rollSku) => {
          let simpleItemBean = {
            code: rollSku.rollSkuNumber,
            description: "",
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = this.state.userInput;
      let filteredSuggestions = new Array();
      filteredSuggestions = simpleAutoCompleteList.filter(
        (list) => list.code.toString().indexOf(userInput.toString()) > -1,
      );
      this.setState({
        rollSkuPageListForAutoCompleteList: filteredSuggestions,
      });
    }
  };

  readRollSkuBySearchString(searchString) {
    // let rollSkuData = [];
    // let rollSkuLookupHandler = this.state.rollSkuLookupHandler.lookupdata;
    // rollSkuLookupHandler.map((sku) => {
    //   rollSkuData.push(sku);
    // });
    // let simpleAutoCompleteList = new Array();
    // if (rollSkuData.length > 0 && rollSkuData != null) {
    //   rollSkuData.map((rollSku) => {
    //     let simpleItemBean = {
    //       code: rollSku.rollSkuNumber,
    //     };
    //     simpleAutoCompleteList.push(simpleItemBean);
    //   });
    // }
    // let userInput = searchString;
    // let filteredSuggestions = new Array();
    // filteredSuggestions = simpleAutoCompleteList.filter(
    //   (list) =>
    //     list.rollSkuNumber.toLowerCase().indexOf(userInput.toLowerCase()) > -1
    // );
    // this.setState({ rollSkuPageListForAutoCompleteList: filteredSuggestions });

    let rollSkuCriteria = new SKUBatchInventorySearchCriteria();
    let criteria = this.state.inventoryTransferLineData;
    rollSkuCriteria.companyCode = this.companyCode;
    rollSkuCriteria.fabricStyleCode = criteria.fabricStyleCode;
    rollSkuCriteria.colorCode = criteria.fabricStyleColorCode;
    let roll_pageList = new RestPageListBean();
    roll_pageList.pageSize = 100;
    let requestInput = new RestSkuBatchInventoryListRequest();
    requestInput.pageInput = roll_pageList;
    requestInput.searchCriteria = rollSkuCriteria;
    this.setState({ userInput: searchString });
    InventoryService.getSkuBatchAllWareHouseInventoryPageList(
      requestInput,
      this.readApplyRollSkuResponse,
      this.readApplyRollResponseError,
    );
  }

  displayAutoCompleteRollSkuList = (isShowAutoCompleteRollSkutList) => {
    this.setState({
      isShowAutoCompleteRollSkutList: isShowAutoCompleteRollSkutList,
    });
  };
  adjustmentOnChange = (e) => {
    let adjustmentCode = e.target.value;
    this.state.isShowAutoCompleteAdjustmentList = true;
    let tempCriteria = this.state.adjustmentCriteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteAdjustmentList;
    if (isEmpty(adjustmentCode)) {
      this.state.isShowAutoCompleteAdjustmentList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteAdjustmentList;
      let criteria = this.state.adjustmentCriteria;
      criteria.adjustmentCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteAdjustmentList: showAutoCompleteList,
        adjustmentCriteria: criteria,
        adjustmentPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "adjustmentCode" &&
      showAutoCompleteList === true &&
      adjustmentCode !== ""
    ) {
      this.readAdjustmentBySearchString(e.target.value);
    }
    tempCriteria["adjustmentCode"] = e.target.value;
    this.setState({ adjustmentCriteria: tempCriteria });
  };
  adjustmentEnterKeyEventHandler = (e) => {
    let adjustmentCode = e.target.value;
    let tempCriteria = this.state.adjustmentCriteria;
    tempCriteria.adjustmentCode = adjustmentCode;
    this.readAndSetRollLines(e.target.value, e.target.name);
    this.setState({
      adjustmentPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteAdjustmentList: false,
      adjustmentCriteria: tempCriteria,
    });
  };
  readAdjustmentBySearchString = (adjustmentCode) => {
    let readrestInput = new RestFabricStyleInventoryAdjustmentListRequest();
    let pageList = new RestPageListBean();
    let criteria = new FabricStyleInventoryAdjustmentSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.adjustmentCodeStartsWith = adjustmentCode;
    readrestInput.searchCriteria = criteria;
    readrestInput.pageInput = pageList;
    if (SecurityAccessManager.InventoryTransferMaintenance_IsAccessible()) {
      InventoryService.getFabricStyleInventoryAdjustmentPageList(
        readrestInput,
        this.readInventoryAdjustmentResponse,
        this.readInventoryAdjustmentError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readInventoryAdjustmentResponse = (response) => {
    if (response.data.fabricStyleInventoryAdjustmentPageList != null) {
      if (
        response.data.fabricStyleInventoryAdjustmentPageList
          .fabricStyleInventoryAdjustments != null
      ) {
        let adJustmentData =
          response.data.fabricStyleInventoryAdjustmentPageList
            .fabricStyleInventoryAdjustments;
        let simpleAutoCompleteList = new Array();
        if (adJustmentData.length > 0 && adJustmentData != null) {
          adJustmentData.map((obj) => {
            let simpleItemBean = {
              code: obj.code,
              description: "",
            };
            simpleAutoCompleteList.push(simpleItemBean);
          });
        }
        this.setState({
          adjustmentPageListForAutoCompleteList: simpleAutoCompleteList,
        });
      }
    }
  };
  readInventoryAdjustmentError = (error) => {
    ShowError("Error : ", error);
  };
  displayAutoCompleteAdjustmentList = (isShowAutoCompleteAdjustmentList) => {
    this.setState({
      isShowAutoCompleteAdjustmentList: isShowAutoCompleteAdjustmentList,
    });
  };
  receiptOnChange = (e) => {
    let purchaseOrderReceiptNumber = e.target.value;
    this.state.isShowAutoCompletepurchaseReceiptList = true;
    let tempCriteria = this.state.receiptCriteria;
    let showAutoCompleteList = this.state.isShowAutoCompletepurchaseReceiptList;
    if (isEmpty(purchaseOrderReceiptNumber)) {
      this.state.isShowAutoCompletepurchaseReceiptList = false;
      let showAutoCompleteList =
        this.state.isShowAutoCompletepurchaseReceiptList;
      let criteria = this.state.receiptCriteria;
      criteria.purchaseOrderReceiptNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompletepurchaseReceiptList: showAutoCompleteList,
        receiptCriteria: criteria,
        purchaseReceiptPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "purchaseOrderReceiptNumber" &&
      showAutoCompleteList === true &&
      purchaseOrderReceiptNumber !== ""
    ) {
      this.readpurchaseReceiptBySearchString(e.target.value);
      // this.readAndSetRollLines(e.target.value, e.target.name);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ receiptCriteria: tempCriteria });
  };
  purchaseReceiptEnterKeyEventHandler = (e) => {
    let purchaseOrderReceiptNumber = e.target.value;
    let tempCriteria = this.state.receiptCriteria;
    tempCriteria.purchaseOrderReceiptNumber = purchaseOrderReceiptNumber;
    this.readAndSetRollLines(e.target.value, e.target.name);
    this.setState({
      receiptCriteria: tempCriteria,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompletepurchaseReceiptList = (
    isShowAutoCompletepurchaseReceiptList,
  ) => {
    this.setState({
      isShowAutoCompletepurchaseReceiptList:
        isShowAutoCompletepurchaseReceiptList,
    });
  };
  readpurchaseReceiptBySearchString(searchString) {
    let receiptCriteria = new PurchaseOrderReceiptSearchCriteria();
    receiptCriteria.companyCode = this.companyCode;
    receiptCriteria.purchaseOrderReceiptNumberStartsWith = searchString;
    let requestInput = new RestPurchaseOrderReceiptListRequest();
    requestInput.pageInput = new RestPageListBean();
    requestInput.searchCriteria = receiptCriteria;
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      PurchaseOrderReceiptService.getPurchaseOrderReceiptPageList(
        requestInput,
        this.loadByPurchaseOrderReceiptResponse,
        this.readBypurchaseReceiptResponseError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  }
  loadByPurchaseOrderReceiptResponse = (response) => {
    let receiptList =
      response.data.purchaseOrderReceiptPageList.purchaseOrderReceipts;
    let simpleAutoCompleteList = new Array();
    if (receiptList.length > 0 && receiptList != null) {
      receiptList.map((receipt) => {
        let simpleItemBean = {
          code: receipt.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      purchaseReceiptPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readBypurchaseReceiptResponseError = (error) => {
    ShowError("Error : ", error);
  };
  readAndSetRollLines = (code, name) => {
    let readrestInput = new RestSkuBatchInventoryListRequest();
    let searchCriteria = new SKUBatchInventorySearchCriteria();
    let pageInput = new PageListBean();
    let inventoryTransferData = this.state.inventoryTransferData;
    searchCriteria.companyCode = this.companyCode;
    if (name === "purchaseOrderReceiptNumber") {
      searchCriteria.purchaseReceitpNumber = code;
    } else if (name === "adjustmentCode") {
      searchCriteria.inventoryAdjustmentNumber = code;
    }
    searchCriteria.locationCode = inventoryTransferData.fromLocationCode;
    readrestInput.searchCriteria = searchCriteria;
    readrestInput.pageInput = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading SKUInventory",
    });
    if (SecurityAccessManager.InventoryAdjustmentMaintenance_IsAccessible()) {
      InventoryService.getSkuBatchInventoryPageList(
        readrestInput,
        this.readSkuBatchInventoryResponse,
        this.readSkuBatchInventoryError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readSkuBatchInventoryResponse = (response) => {
    if (response.data.skuBatchInventoryPageList != null) {
      if (response.data.skuBatchInventoryPageList.skuBatchInventories != null) {
        let rollLines =
          response.data.skuBatchInventoryPageList.skuBatchInventories;
        let roll_Lines = [];
        if (rollLines != null) {
          rollLines.map((line, i) => {
            roll_Lines.push(line);
          });
        }
        this.setState({
          roll_Lines: roll_Lines,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readSkuBatchInventoryError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("readSkuBatchInventoryError:" + error);
  };
  openPurchaseReceiptPopup = () => {
    this.setState({
      isShowReceiptPopup: true,
      receiptCriteria: new PurchaseOrderReceiptSearchCriteria(),
      isShowAutoCompletepurchaseReceiptList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
    });
  };
  openInvAdjustmentPopup = () => {
    this.setState({
      isShowAdjustmentPopup: true,
      adjustmentCriteria: new FabricStyleInventoryAdjustmentSearchCriteria(),
      isShowAutoCompleteAdjustmentList: false,
      adjustmentPageListForAutoCompleteList: new Array(),
    });
  };
  closePurchaseReceiptPopup = () => {
    this.setState({
      isShowReceiptPopup: false,
      receiptCriteria: new PurchaseOrderReceiptSearchCriteria(),
      isShowAutoCompletepurchaseReceiptList: false,
      purchaseReceiptPageListForAutoCompleteList: new Array(),
    });
  };
  closeInvAdjustmentPopup = () => {
    this.setState({
      isShowAdjustmentPopup: false,
      adjustmentCriteria: new FabricStyleInventoryAdjustmentSearchCriteria(),
      isShowAutoCompleteAdjustmentList: false,
      adjustmentPageListForAutoCompleteList: new Array(),
    });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let inventory_transfer_list = this.state.inventory_transfer_list;
    if (sortField && !isEmptyArray(inventory_transfer_list)) {
      const sorted = [...inventory_transfer_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inventory_transfer_list: sorted });
    }
  };
  render() {
    let excelInventoryList = this.state.excelInventoryList;
    let excelIncompleteInventoryList = this.state.excelIncompleteInventoryList;
    let inventoryTransferData = this.state.inventoryTransferData;
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "359px",
          maxHeight: "359px",
        },
      },
    };
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowExcelDataPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Inventory Adjustment Roll Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          headerButtonContainer={
            <div className="floatLeft">
              <Button
                className="header_buttons enterFocus"
                size="sm"
                onClick={(e) => this.addExcelDataLine(e)}
              >
                Add line
              </Button>
            </div>
          }
          content={
            <div className="header_div">
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>Inventory</FormLabel>
                  </Col>
                  <Col sm="2">
                    <InputTextbox
                      value={inventoryTransferData.code}
                      disabled={true}
                    ></InputTextbox>
                  </Col>
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.selectAllExcelLine(e)}
                    >
                      SelectAll
                    </Button>
                  </Col>
                  <Col sm="1">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.unSelectAllExcelLine(e)}
                    >
                      UnSelectAll
                    </Button>
                  </Col>
                </Row>
              </div>
              <div>
                <div className="div_default">
                  <FormLabel>InventoryLines</FormLabel>
                  {this.state.excelInventoryList != null &&
                    !isEmptyArray(this.state.excelInventoryList) && (
                      // <EditableDataGrid
                      //   customStyles={styles}
                      //   columnsList={this.excelListColumnDefinitions()}
                      //   dataList={excelInventoryList}
                      // />
                      <CustomTable
                        columns={this.excelListColumns()}
                        data={excelInventoryList}
                      />
                    )}
                </div>
                <div className="div_default">
                  <FormLabel>InCompleteInventoryLines</FormLabel>
                  {this.state.excelInventoryList != null &&
                    !isEmptyArray(this.state.excelInventoryList) && (
                      // <EditableDataGrid
                      //   customStyles={styles}
                      //   columnsList={this.excelListColumnDefinitions()}
                      //   dataList={excelIncompleteInventoryList}
                      // />
                      <CustomTable
                        columns={this.excelListColumns()}
                        data={excelIncompleteInventoryList}
                      />
                    )}
                </div>
              </div>
              {/* <Row>
                <Col sm="6">
                  <FormLabel>InventoryLines</FormLabel>
                  {this.state.excelInventoryList != null &&
                    !isEmptyArray(this.state.excelInventoryList) && (
                      <EditableDataGrid
                        customStyles={styles}
                        columnsList={this.excelListColumnDefinitions()}
                        dataList={excelInventoryList}
                      />
                    )}
                </Col>
                <Col sm="6" style={{ "border-left": "1px solid grey" }}>
                  <FormLabel>InCompleteInventoryLines</FormLabel>
                  {this.state.excelInventoryList != null &&
                    !isEmptyArray(this.state.excelInventoryList) && (
                      <EditableDataGrid
                        customStyles={styles}
                        columnsList={this.excelListColumnDefinitions()}
                        dataList={excelIncompleteInventoryList}
                      />
                    )}
                </Col>
              </Row> */}
            </div>
          }
        />
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <ModuleToolBar
          isShowNewButton={false}
          onNewEntry={() => this.addNewEntry()}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
          isMaintenanceMode={this.state.isMaintenanceMode}
          onModuleKeyContainerButtonClick={this.editInventoryTransfer}
          moduleKeyCode={this.state.moduleKeyCode}
          onModuleKeyCodeChange={this.onModuleKeyCodeChange}
          getModuleListView={this.getModuleListView}
          lookupRequired={true} //for f2 lookup
          lookupHandler={this.state.inventoryTransferLookupHandler} //for f2 lookup
          showCriteriaDialog={true} //for f2 lookup
          onModuleKeyCodeWithCriteriaOnChange={
            this.onModuleKeyCodeWithCriteriaOnChange
          }
          isSpecialViewMode={this.state.isSpecialViewMode}
          selectButtonClick={this.selectButtonClick}
          disabled={this.state.disabled}
          isResetView={this.state.isResetView}
          isFocusLookup={this.state.isFocusLookup}
        />

        {!this.state.isInventoryTransferListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFReportButton}
              pageTitle={this.state.pageTitle}
            />
          )}
        {this.state.isInventoryTransferListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <InventoryTransferListForm
              {...this.state}
              inventory_transfer_list={this.state.inventory_transfer_list}
              pageList={this.state.pageList}
              criteria={this.state.criteria}
              filterInventoryTransfer={this.filterInventoryTransfer}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editInventoryTransfer={this.editInventoryTransfer}
              resetfilteredTransfer={this.resetfilteredTransfer}
              isLoading={this.state.isLoading}
              searchOnChange={this.searchOnChange}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        {this.state.isTransferEntryFormOpen && (
          <InventoryTransferForm
            {...this.state}
            inventoryTransferData={this.state.inventoryTransferData}
            inventoryTransferLineData={this.state.inventoryTransferLineData}
            saveInventoryTransfer={this.saveInventoryTransfer}
            closeEntryForm={this.closeEntryForm}
            inventoryTransferReasons={this.state.inventoryTransferReasons}
            warehouses={this.state.warehouses}
            documentTypes={this.state.documentTypes}
            fabricStyle_List={this.state.fabricStyle_List}
            onLineChange={this.onLineChange}
            // onFabricColorChange={this.onFabricColorChange}
            readSelectedFabricStyle={this.readSelectedFabricStyle}
            onChange={this.onChange}
            addOrUpdateLineChange={this.addOrUpdateLineChange}
            fabricStyleColorCodeRef={this.fabricStyleColorCodeRef}
            fabricStyleCodeRef={this.fabricStyleCodeRef}
            clearLineValues={this.clearLineValues}
            fabricRollCriteriaOnChange={this.fabricRollCriteriaOnChange}
            fabricFetchRolls={this.fabricFetchRolls}
            fabricStyleRollList={this.state.fabricStyleRollList}
            receiptList={this.state.receiptList}
            receiptCriteria={this.state.receiptCriteria}
            // receiptOnChange={this.receiptOnChange}
            loadRollLines={this.loadRollLines}
            adjustmentList={this.state.adjustmentList}
            adjustmentCriteria={this.state.adjustmentCriteria}
            getLineDetails={this.getLineDetails}
            inventoryRollList={this.state.inventoryRollList}
            binInventoryList={this.state.binInventoryList}
            uploadExcelFile={this.uploadExcelFile}
            deleteTransferLines={this.deleteTransferLines}
            fromLocationOnChange={this.fromLocationOnChange}
            fromLocationEnterKeyEventHandler={
              this.fromLocationEnterKeyEventHandler
            }
            toLocationOnChange={this.toLocationOnChange}
            toLocationEnterKeyEventHandler={this.toLocationEnterKeyEventHandler}
            displayFromLocationAutoCompleteList={
              this.displayFromLocationAutoCompleteList
            }
            displayToLocationAutoCompleteList={
              this.displayToLocationAutoCompleteList
            }
            onDocumentChange={this.onDocumentChange}
            documentEnterKeyEventHandler={this.documentEnterKeyEventHandler}
            displayAutoCompleteDocumentList={
              this.displayAutoCompleteDocumentList
            }
            transferReasonOnChange={this.transferReasonOnChange}
            transferReasonEnterKeyEventHandler={
              this.transferReasonEnterKeyEventHandler
            }
            displayAutoCompleteTransferReasonList={
              this.displayAutoCompleteTransferReasonList
            }
            fabricCodeOnChange={this.fabricCodeOnChange}
            fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
            displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
            colorOnChange={this.colorOnChange}
            colorEnterKeyEventHandler={this.colorEnterKeyEventHandler}
            displayAutoCompleteColorList={this.displayAutoCompleteColorList}
            rollSkuOnChange={this.rollSkuOnChange}
            rollSkuEnterKeyEventHandler={this.rollSkuEnterKeyEventHandler}
            displayAutoCompleteRollSkuList={this.displayAutoCompleteRollSkuList}
            adjustmentOnChange={this.adjustmentOnChange}
            adjustmentEnterKeyEventHandler={this.adjustmentEnterKeyEventHandler}
            displayAutoCompleteAdjustmentList={
              this.displayAutoCompleteAdjustmentList
            }
            receiptOnChange={this.receiptOnChange}
            purchaseReceiptEnterKeyEventHandler={
              this.purchaseReceiptEnterKeyEventHandler
            }
            displayAutoCompletepurchaseReceiptList={
              this.displayAutoCompletepurchaseReceiptList
            }
            openPurchaseReceiptPopup={this.openPurchaseReceiptPopup}
            openInvAdjustmentPopup={this.openInvAdjustmentPopup}
            closePurchaseReceiptPopup={this.closePurchaseReceiptPopup}
            closeInvAdjustmentPopup={this.closeInvAdjustmentPopup}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
          />
        )}
      </div>
    );
  }
}
class InventoryTransferListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      criteria: new InventoryLocationTransferSearchCriteria(),
      filter: "",
      pageList: this.props.pageList,
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  searchOnChange = (e) => {
    this.props.searchOnChange(e);
  };
  filterInventoryTransfer = (e) => {
    if (e.detail == 1) this.props.filterInventoryTransfer();
  };
  resetfilteredTransfer = (e) => {
    let criteria = this.props.criteria;
    if (e.detail == 1) this.props.resetfilteredTransfer(criteria);
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editInventoryTransfer = (e, val, rowData) => {
    if (e.detail == 1) this.props.editInventoryTransfer(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filterInventoryTransfer();
    }
  };
  render() {
    let inventory_transfer_list = this.props.inventory_transfer_list;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let isLoading = this.props.isLoading;
    return (
      <div>
        <div className="secondary_module_header">
          <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="transferCode"
                type="text"
                value={criteria.transferCode}
                placeholder="Enter Value to Filter.."
                onChange={this.searchOnChange}
                onKeyDown={this.onKeyDown}
              />
              <Button onClick={(e) => this.filterInventoryTransfer(e)}>
                Filter
              </Button>
              <Button onClick={(e) => this.resetfilteredTransfer(e)}>
                Reset
              </Button>
            </span>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  TransferCode
                  {this.state.order === "desc" &&
                  this.state.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "transferReason")}
                >
                  Reason
                  {this.state.order === "desc" &&
                  this.state.sortField === "transferReason" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "documentNumber")}
                >
                  DocumentNumber
                  {this.state.order === "desc" &&
                  this.state.sortField === "documentNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "documentType")}
                >
                  DocumentType
                  {this.state.order === "desc" &&
                  this.state.sortField === "documentType" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "createdDate")}>
                  CreatedDate
                  {this.state.order === "desc" &&
                  this.state.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {inventory_transfer_list != null ? (
              <tbody>
                {inventory_transfer_list.map((inv, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editInventoryTransfer(e, inv.code)}
                      >
                        {inv.code}
                      </Button>
                    </td>
                    <td>{inv.transferReason}</td>
                    <td>{inv.documentNumber}</td>
                    <td>{inv.documentType}</td>
                    <td>{inv.createdDate}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {inventory_transfer_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class InventoryTransferForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      inventoryTransferData: this.props.inventoryTransferData,
      inventoryTransferLineData: this.props.inventoryTransferLineData,
      inventoryTransferReasons: this.props.inventoryTransferReasons,
      isShowElements: false,
    };
    this.fabricStyleColorCodeRef = this.props.fabricStyleColorCodeRef;
    this.fabricStyleCodeRef = this.props.fabricStyleCodeRef;
    this.rollSkuCodeRef = React.createRef();
    this.receiptCodeRef = React.createRef();
    this.adjustmentCodeRef = React.createRef();
    this.warehouseRef = React.createRef();
    this.toWarehouseRef = React.createRef();
    this.transferReasonRef = React.createRef();
    this.documentTypeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
    this.setInputFocus();
  }
  setInputFocus = () => {
    if (this.props.moduleKeyCode === "NEW") {
      this.transferReasonRef.current.focus();
    }
  };
  initLookupHandlers = () => {
    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.props.warehouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let transferReasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.inventoryTransferReasons,
      "Transfer Reason",
    );
    this.setState({ transferReasonLookupHandler: transferReasonLookupHandler });
    let documentTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.documentTypes,
      "Document Type",
    );
    this.setState({ documentTypeLookupHandler: documentTypeLookupHandler });
    let purchaseOrderReceiptLookupHandler =
      new PurchaseOrderReceiptLookupHandler(
        this.companyCode,
        "Purchase Receipt",
      );
    this.setState({
      purchaseOrderReceiptLookupHandler: purchaseOrderReceiptLookupHandler,
    });
    let inventoryAdjustmentLookupHandler = new InventoryAdjustmentLookupHandler(
      this.companyCode,
      "Inventory Adjustment",
    );
    this.setState({
      inventoryAdjustmentLookupHandler: inventoryAdjustmentLookupHandler,
    });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.props.is3PL ? "Item" : "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  lineColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true)
        .setStyleDetails("right", "", "", "wt-2", "wt-2")
        .setClickDetails(true, false, this.handleLineNumberClick, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Item" : "FabricStyle",
          "fabricStyleCode",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "ItemName" : "FabricStyleName",
          "fabricStyleShortName",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      // .setClickDetails(true, false, this.lnkCustomerModule,null )
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(
          this.state.is3PL ? "Inventory#" : "RollSKU#",
          "rollSkuNumber",
          true,
        )
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails(this.state.is3PL ? "Seq#" : "Roll#", "rollNumber", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Bin#", "aisleInfoText", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Transfer Qty#", "transferQuantity", true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM#", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FromLocation", "fromLocationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ToLocation", "toLocationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        .setStyleDetails("", "", "", "wt-2", "wt-2")

        .setClickDetails(false, true, this.deleteClickCallback, <DeleteIcon />),
    );

    return columns;
  };

  lineColumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Ln#",
        "lineNumber",
        1,
        true,
        this.handleLineNumberClick,
      ),
    );
    if (this.props.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item", "fabricStyleCode"),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails(
          "FabricStyle",
          "fabricStyleCode",
        ),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails("Name", "fabricStyleShortName"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Color",
        "fabricStyleColorCode",
      ),
    );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails("WidthCode", "widthCode")
    // );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Inventor#" : "RollSKU#",
        "rollSkuNumber",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Roll#", "rollNumber"),
    );
    // columnList.push(
    //   new DataGridColumnDefinition().setDetails(
    //     "VendorLot#",
    //     "vendorBatchNumber"
    //   )
    // );
    columnList.push(
      new DataGridColumnDefinition().setDetails("Bin#", "aisleInfoText"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Transfer Qty#",
        "transferQuantity",
        1,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("UOM", "uomCode"),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "FromLocation",
        "fromLocationCode",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails("ToLocation", "toLocationCode"),
    );
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          <DeleteIcon />,
          // true,
          1,
          false,
          null,
          false,
          null, //image link call back
          "1em", //min-width
          "3%", //max-width
          false,
          null,
          false,
        )
        .setEditableDetails(
          false,
          "",
          null,
          true,
          this.deleteClickCallback,
          false,
          null,
        ),
    );
    return columnList;
  };
  onLineChange = (e) => {
    this.props.onLineChange(e);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  addUpdateLine = (e) => {
    if (e.detail <= 1) this.props.addOrUpdateLineChange(e);
  };
  clearLineValues = (e) => {
    if (e.detail <= 1) this.props.clearLineValues();
  };
  handleLineNumberClick = (e, val, rowData) => {
    this.props.getLineDetails(rowData);
  };
  deleteClickCallback = (e, val, rowData) => {
    this.props.deleteTransferLines(rowData);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.props.closeAlertModalCallBack(isShowPopup);
  };
  onExcelClick = (e) => {
    if (e.detail <= 1) {
      const input = document.getElementById("file-input");
      if (input) {
        input.click();
      }
    }
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  fromLocationOnChange = (e) => {
    this.props.fromLocationOnChange(e);
  };
  fromLocationEnterKeyEventHandler = (e) => {
    this.props.fromLocationEnterKeyEventHandler(e);
  };
  toLocationOnChange = (e) => {
    this.props.toLocationOnChange(e);
  };
  toLocationEnterKeyEventHandler = (e) => {
    this.props.toLocationEnterKeyEventHandler(e);
  };
  displayFromLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayFromLocationAutoCompleteList(showAutoCompleteList);
  };
  displayToLocationAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayToLocationAutoCompleteList(showAutoCompleteList);
  };
  onDocumentChange = (e) => {
    this.props.onDocumentChange(e);
  };
  documentEnterKeyEventHandler = (e) => {
    this.props.documentEnterKeyEventHandler(e);
  };
  displayAutoCompleteDocumentList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteDocumentList(showAutoCompleteList);
  };
  transferReasonOnChange = (e) => {
    this.props.transferReasonOnChange(e);
  };
  transferReasonEnterKeyEventHandler = (e) => {
    this.props.transferReasonEnterKeyEventHandler(e);
  };
  displayAutoCompleteTransferReasonList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteTransferReasonList(showAutoCompleteList);
  };
  fabricCodeOnChange = (e) => {
    this.props.fabricCodeOnChange(e);
  };
  fabricEnterKeyEventHandler = (e) => {
    this.props.fabricEnterKeyEventHandler(e);
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteFabricList(showAutoCompleteList);
  };
  colorOnChange = (e) => {
    this.props.colorOnChange(e);
  };
  colorEnterKeyEventHandler = (e) => {
    this.props.colorEnterKeyEventHandler(e);
  };
  displayAutoCompleteColorList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteColorList(showAutoCompleteList);
  };
  rollSkuOnChange = (e) => {
    this.props.rollSkuOnChange(e);
  };
  rollSkuEnterKeyEventHandler = (e) => {
    this.props.rollSkuEnterKeyEventHandler(e);
  };
  displayAutoCompleteRollSkuList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteRollSkuList(showAutoCompleteList);
  };
  adjustmentOnChange = (e) => {
    this.props.adjustmentOnChange(e);
  };
  adjustmentEnterKeyEventHandler = (e) => {
    this.props.adjustmentEnterKeyEventHandler(e);
  };
  displayAutoCompleteAdjustmentList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteAdjustmentList(showAutoCompleteList);
  };
  receiptOnChange = (e) => {
    this.props.receiptOnChange(e);
  };
  purchaseReceiptEnterKeyEventHandler = (e) => {
    this.props.purchaseReceiptEnterKeyEventHandler(e);
  };
  displayAutoCompletepurchaseReceiptList = (showAutoCompleteList) => {
    this.props.displayAutoCompletepurchaseReceiptList(showAutoCompleteList);
  };
  loadInvAdjustment = (e) => {
    if (this.adjustmentCodeRef.current != null) {
      this.adjustmentCodeRef.current.clear();
    }
    if (e.detail <= 1) this.props.openInvAdjustmentPopup();
  };
  loadPurchaseReceipt = (e) => {
    if (this.receiptCodeRef.current != null) {
      this.receiptCodeRef.current.clear();
    }
    if (e.detail <= 1) this.props.openPurchaseReceiptPopup();
  };
  loadRollLines = (e) => {
    if (e.detail <= 1) this.props.loadRollLines();
    this.props.closePurchaseReceiptPopup();
    this.props.closeInvAdjustmentPopup();
  };

  render() {
    let inventoryTransferData = null;
    let inventoryTransferLineData = this.props.inventoryTransferLineData;
    inventoryTransferData = this.props.inventoryTransferData;
    let transferLines = inventoryTransferData.transferLines;
    let binInventoryList = this.props.binInventoryList;
    if (!binInventoryList) {
      binInventoryList = new Array();
    }
    let adjustmentCriteria = this.props.adjustmentCriteria;
    let receiptCriteria = this.props.receiptCriteria;
    var styles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "170px",
          maxHeight: "170px",
          overflowY: "auto",
        },
      },
    };
    const textAreaStyle = {
      maxHeight: "9em",
      width: "40em",
      resize: "none",
      padding: "9px",
      boxSizing: "border-box",
      fontSize: "12px",
    };
    let isDisabledFields = this.props.isDisabledFields;
    return (
      <div>
        <div className="header_div">
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>InventoryTransfer#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              {" "}
              <InputTextbox
                name="code"
                type="text"
                onChange={this.onChange}
                // readOnly={true}
                value={inventoryTransferData.code}
                disabled={true}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Transfer Reason</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.transferReasonOnChange}
                ref={this.transferReasonRef}
                name="transferReason"
                placeholder="transferReason"
                value={inventoryTransferData.transferReason}
                lookupRequired={true}
                lookupHandler={this.state.transferReasonLookupHandler}
                enterKeyEventHandler={this.transferReasonEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.transferReasonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayAutoCompleteTransferReasonList
                }
                showAutoCompleteList={
                  this.props.isShowAutoCompleteTransferReasonList
                }
                readOnly={isDisabledFields}
                disabled={isDisabledFields}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>FromLocation</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.fromLocationOnChange}
                placeholder="fromLocationCode"
                ref={this.warehouseRef}
                name="fromLocationCode"
                value={inventoryTransferData.fromLocationCode}
                lookupRequired={true}
                lookupHandler={this.state.warehouseLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.fromLocationEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.fromLocationPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={
                  this.displayFromLocationAutoCompleteList
                }
                showAutoCompleteList={
                  this.props.isShowAutoCompleteFromLocationList
                }
                readOnly={isDisabledFields}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              <FormLabel>ToLocation</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.toLocationOnChange}
                placeholder="toLocationCode"
                ref={this.toWarehouseRef}
                name="toLocationCode"
                value={inventoryTransferData.toLocationCode}
                lookupRequired={true}
                lookupHandler={this.state.warehouseLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.toLocationEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.toLocationPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayToLocationAutoCompleteList}
                showAutoCompleteList={
                  this.props.isShowAutoCompleteToLocationList
                }
                readOnly={isDisabledFields}
                disabled={isDisabledFields}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              <FormLabel>DocumentType</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.onDocumentChange}
                ref={this.documentTypeRef}
                name="documentType"
                placeholder="documentType"
                value={inventoryTransferData.documentType}
                lookupRequired={true}
                lookupHandler={this.state.documentTypeLookupHandler}
                enterKeyEventHandler={this.documentEnterKeyEventHandler}
                autoCompleteListData={
                  this.props.documentPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayAutoCompleteDocumentList}
                showAutoCompleteList={this.props.isShowAutoCompleteDocumentList}
                readOnly={isDisabledFields}
                disabled={isDisabledFields}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <FormLabel>Document#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="documentNumber"
                placeholder="Enter documentNumber"
                onChange={this.onChange}
                value={inventoryTransferData.documentNumber}
                readOnly={isDisabledFields}
                disabled={isDisabledFields}
              />{" "}
            </Col>
            <Col sm="1">
              <FormLabel>Remarks</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <textarea
                style={textAreaStyle}
                className="form-control"
                name="remarks"
                type="text"
                placeholder="Enter remarks"
                onChange={this.onChange}
                value={inventoryTransferData.remarks}
                readOnly={isDisabledFields}
                disabled={isDisabledFields}
              />
            </Col>
          </Row>
        </div>
        <div className="header_div col-md-12 col-lg-12">
          <div>
            <Row>
              <Col sm="2" className="title_text_div">
                <FormLabel className="label_head">Inv Transfer Lines</FormLabel>
              </Col>
              {this.props.isLoadExcelButton && (
                <Col sm="8">
                  <Button
                    className="enterFocus"
                    size="sm"
                    id="fabric_Add_Button"
                    onClick={(e) => this.onExcelClick(e)}
                  >
                    Load From Excel
                  </Button>
                  <input
                    type="file"
                    id="file-input"
                    style={{ display: "none" }}
                    onChange={this.uploadExcelFile}
                    accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
                  />
                  <Button
                    className="enterFocus"
                    id="fabric_Add_Button"
                    size="sm"
                    onClick={(e) => this.loadPurchaseReceipt(e)}
                  >
                    Load From Purchase Receipt
                  </Button>
                  <Button
                    className="enterFocus"
                    id="fabric_Add_Button"
                    size="sm"
                    onClick={(e) => this.loadInvAdjustment(e)}
                  >
                    Load From InventoryAdjustment
                  </Button>
                </Col>
              )}
            </Row>
          </div>
          <div className="div_default">
            {/* <EditableDataGrid
              styles={styles}
              columnsList={this.lineColumnDefinitions()}
              dataList={transferLines}
            /> */}
            <CustomTable columns={this.lineColumns()} data={transferLines} />
          </div>
          <div>
            <div>
              <Row>
                <Col sm="2" className="title_text_div">
                  <FormLabel className="label_head">
                    Inv Transfer Detail
                  </FormLabel>
                </Col>
              </Row>
            </div>
            <div className="div_default">
              <Row>
                <Col sm="1">
                  <FormLabel>Line#</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="lineNumber"
                    type="text"
                    onChange={this.onLineChange}
                    readOnly={true}
                    value={inventoryTransferLineData.lineNumber}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  {this.props.is3PL ? (
                    <FormLabel>Item</FormLabel>
                  ) : (
                    <FormLabel>FabricSTyle</FormLabel>
                  )}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.fabricCodeOnChange}
                    ref={this.fabricStyleCodeRef}
                    name="fabricStyleCode"
                    value={inventoryTransferLineData.fabricStyleCode}
                    lookupRequired={true}
                    lookupHandler={this.state.fabricLookupHandler}
                    enterKeyEventHandler={this.fabricEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.fabricPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteFabricList}
                    showAutoCompleteList={
                      this.props.isShowAutoCompleteFabricList
                    }
                    readOnly={isDisabledFields}
                    disabled={isDisabledFields}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
                <Col sm="3">
                  <InputTextbox
                    name="fabricStyleShortName"
                    type="text"
                    value={inventoryTransferLineData.fabricStyleShortName}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    placeholder="Enter Color"
                    value={inventoryTransferLineData.fabricStyleColorCode}
                    onChange={this.colorOnChange}
                    lookupRequired={this.props.isShowColorLookup}
                    lookupHandler={this.props.colorLookupHandler}
                    enterKeyEventHandler={this.colorEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.colorPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={this.displayAutoCompleteColorList}
                    showAutoCompleteList={
                      this.props.isShowAutoCompleteColorList
                    }
                    readOnly={isDisabledFields}
                    disabled={!this.props.isShowColorLookup}
                    isMandatory={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Width</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="widthCode"
                    type="text"
                    value={inventoryTransferLineData.widthCode}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>
                    {this.props.is3PL ? "Inventory#" : "RollSKU#"}
                  </FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    onChange={this.rollSkuOnChange}
                    name="rollSkuNumber"
                    placeholder={this.props.is3PL ? "Inventory#" : "RollSKU#"}
                    value={inventoryTransferLineData.rollSkuNumber}
                    lookupRequired={this.props.isShowRollSkuLookup}
                    lookupHandler={this.props.rollSkuLookupHandler}
                    enterKeyEventHandler={this.rollSkuEnterKeyEventHandler}
                    autoCompleteListData={
                      this.props.rollSkuPageListForAutoCompleteList
                    }
                    enableAutoCompleteTextBox={true}
                    displayAutoCompleteList={
                      this.displayAutoCompleteRollSkuList
                    }
                    showAutoCompleteList={
                      this.props.isShowAutoCompleteRollSkutList
                    }
                    disabled={!this.props.isShowRollSkuLookup}
                    isMandatory={true}
                  ></InputTextbox>
                </Col>
                <Col sm="1">
                  <FormLabel>Roll#</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="rollNumber"
                    type="text"
                    value={inventoryTransferLineData.rollNumber}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Box</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="boxNumber"
                    type="text"
                    value={inventoryTransferLineData.boxNumber}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Vendor Lot</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="vendorBatchNumber"
                    type="text"
                    value={inventoryTransferLineData.vendorBatchNumber}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>UOM</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="uomCode"
                    type="text"
                    value={inventoryTransferLineData.uomCode}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>TransferQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    name={"transferQuantity"}
                    onChange={this.onLineChange}
                    value={inventoryTransferLineData.transferQuantity}
                    className="text-right"
                    decimalScale={2}
                    // readOnly={true}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>FromLocation</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fromLocationCode"
                    type="text"
                    value={inventoryTransferLineData.fromLocationCode}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>ToLocation</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="toLocationCode"
                    type="text"
                    value={inventoryTransferLineData.toLocationCode}
                    onChange={this.onLineChange}
                    readOnly={true}
                  />
                </Col>
                <Col sm="4">
                  <div>
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm"
                      onClick={(e) => this.addUpdateLine(e)}
                      disabled={isDisabledFields}
                    >
                      Add/Update
                    </Button>
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm"
                      onClick={(e) => this.clearLineValues(e)}
                      disabled={isDisabledFields}
                    >
                      Clear
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.props.isShowReceiptPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Load From Purchase Receipt"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="header_div">
              <div>
                <Row className="d-flex justify-content-center">
                  <Col sm="2">
                    <FormLabel>PurchaseReceipt</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.receiptOnChange}
                      ref={this.receiptCodeRef}
                      name="purchaseOrderReceiptNumber"
                      placeholder="purchaseOrderReceiptNumber"
                      value={receiptCriteria.purchaseOrderReceiptNumber}
                      lookupRequired={true}
                      lookupHandler={
                        this.state.purchaseOrderReceiptLookupHandler
                      }
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.purchaseReceiptEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.purchaseReceiptPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompletepurchaseReceiptList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompletepurchaseReceiptList
                      }
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>
                  <Col sm="2">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.loadRollLines(e)}
                    >
                      Go
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.props.isShowAdjustmentPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel1"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Load From Inventory Adjustment"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="header_div">
              <div>
                <Row className="d-flex justify-content-center">
                  <Col sm="2">
                    <FormLabel>Adjustment#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.adjustmentOnChange}
                      ref={this.adjustmentCodeRef}
                      name="adjustmentCode"
                      placeholder="adjustmentCode"
                      value={adjustmentCriteria.adjustmentCode}
                      lookupRequired={true}
                      lookupHandler={
                        this.state.inventoryAdjustmentLookupHandler
                      }
                      enterKeyEventHandler={this.adjustmentEnterKeyEventHandler}
                      autoCompleteListData={
                        this.props.adjustmentPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoCompleteAdjustmentList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteAdjustmentList
                      }
                      readOnly={isDisabledFields}
                      disabled={isDisabledFields}
                      isMandatory={true}
                    ></InputTextbox>
                  </Col>
                  <Col sm="2">
                    <Button
                      id="fabric_Add_Button"
                      className="enterFocus"
                      size="sm1"
                      onClick={(e) => this.loadRollLines(e)}
                    >
                      Go
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
function InventoryTransferModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <InventoryTransferList {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default InventoryTransferModule;
